<template>
  <List style="height: 100%">
    <ListItemGroup :value="selectedIndex">
      <template v-for="(candidate, index) in candidates">
        <ListItem
            :key="index"
            :value="candidate.id"
            three-line
            @click="onSelectCandidate"
        >
          <ListItemContent>
            <ListItemTitle>{{candidate.job.name}}</ListItemTitle>
            <ListItemSubtitle class="body-1">
              <div class="d-flex flex-column">
                <FlexRow class="mt-2" align="center">
                  <Chip v-if="client" outlined un-clickable>
                    {{applicationStatusLabel(candidate)}}
                  </Chip>
                  <ApplicationTypeChip :via-request="candidate.viaRequest" />
                </FlexRow>
                <div class="my-2 d-flex flex-row justify-space-between">
                  <div class="d-flex flex-row align-baseline">
                    <div>
                      {{fullName(candidate.user)}}
                    </div>
                    <Chip
                      v-if="candidate.unreadCount !== 0"
                      class="ml-2"
                      color="red"
                      textColor="white"
                      un-clickable
                    >
                      {{candidate.unreadCount}}
                    </Chip>
                  </div>
                  <div>
                    {{messagedAt(candidate.latestUtterance)}}
                  </div>
                </div>
                <div>
                  {{truncate(detail(candidate.latestUtterance), 25)}}
                </div>
              </div>
            </ListItemSubtitle>
          </ListItemContent>
        </ListItem>
        <Divider
            :key="`divider-${index}`"
        />
      </template>
    </ListItemGroup>
  </List>
</template>

<script>
import List from "@/components/atoms/List";
import ListItem from "@/components/atoms/ListItem";
import ListItemContent from "@/components/atoms/ListItemContent";
import ListItemTitle from "@/components/atoms/ListItemTitle";
import ListItemSubtitle from "@/components/atoms/ListItemSubtitle";
import ComponentMixin from "@/components/ComponentMixin";
import ListItemGroup from "@/components/atoms/ListItemGroup";
import Chip from "@/components/atoms/Chip";
import Divider from "@/components/atoms/Divider";
import {jobApplicationStatus} from "../../enums";
import ApplicationTypeChip from "../molecules/ApplicationTypeChip";
import FlexRow from "../atoms/FlexRow";
export default {
  mixins: [ComponentMixin],
  name: "MessageCandidateList",
  components: {
    FlexRow,
    ApplicationTypeChip,
    Divider, Chip, ListItemGroup, ListItemSubtitle, ListItemTitle, ListItemContent, ListItem, List},
  props: {
    candidates: {
      type: Array,
    },
    value: {
      type: String
    },
    client: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messagedAt() {
      return (utterance) => {
        if (utterance) {
          return this.toDaysAfter(utterance.createdAt) === 0 ? this.fromNow(utterance.createdAt) : this.dateToText(utterance.createdAt);
        }
        return ""
      }
    },
    detail() {
      return (utterance) => {
        if (utterance) {
          return utterance.detail;
        }
        return ""
      }
    },
    selectedIndex() {
      return this.candidates.findIndex(candidate => candidate.id === this.value)
    },
    applicationStatusLabel() {
      return (candidate) => {
        if (candidate.job.isSide) {
          return this.constsToText(candidate.applicationStatus, jobApplicationStatus.side)
        }
        return this.constsToText(candidate.applicationStatus, jobApplicationStatus.regular)
      }
    }
  },
  methods: {
    fullName (user) {
      const lastName = user.lastName || ""
      const firstName = user.firstName || ""
      return lastName + " " + firstName
    },
    onSelectCandidate(value) {
      this.$emit("selectCandidate", value);
    }
  }
}
</script>

<style scoped>

</style>
